module.exports = __webpack_public_path__ + "media/images/certificate-preview-31de48647c2a6147b6195ba31365d01a.png";